import { TagCategory } from '@exam-management/graphql';

interface SearchTag {
  category: string | null;
  name: string | null;
}

export function getDifficultyText(tags: SearchTag[]): string {
  const difficultyTag = tags.find((t) => t.category === TagCategory.Difficulty);
  const calculationTag = tags.find((t) => t.category === TagCategory.Calculation);

  const difficulty = difficultyTag?.name ?? 'ไม่มีข้อมูล';
  const calculation = calculationTag?.name ?? 'ไม่มีข้อมูล';

  return `${difficulty}, ${calculation}`;
}

export function sanitizeContentHtml(html: string): string {
  if (!html) return html;
  const parser = new DOMParser();
  const doc = parser.parseFromString(html, 'text/html');

  doc.querySelectorAll<HTMLElement>('*').forEach((el) => {
    el.style.removeProperty('font-size');
    if (el.getAttribute('style') === '') {
      el.removeAttribute('style');
    }

    Array.from(el.classList).forEach((cls) => {
      if (/font-size|ql-size/.test(cls)) {
        el.classList.remove(cls);
      }
    });
  });

  doc.querySelectorAll<HTMLElement>('mark.search-highlight').forEach((mark) => {
    if (!mark.isConnected) return;
    let node: ChildNode | null = mark.nextSibling;
    while (node) {
      if (node.nodeType === Node.TEXT_NODE && node.textContent?.trim() === '') {
        const whitespace = node;
        const after = whitespace.nextSibling;
        if (
          after?.nodeType === Node.ELEMENT_NODE &&
          (after as Element).tagName === 'MARK' &&
          (after as Element).classList.contains('search-highlight')
        ) {
          mark.innerHTML += (whitespace.textContent ?? '') + (after as Element).innerHTML;
          node = after.nextSibling;
          whitespace.remove();
          after.remove();
        } else {
          break;
        }
      } else if (
        node.nodeType === Node.ELEMENT_NODE &&
        (node as Element).tagName === 'MARK' &&
        (node as Element).classList.contains('search-highlight')
      ) {
        mark.innerHTML += (node as Element).innerHTML;
        const toRemove = node;
        node = toRemove.nextSibling;
        toRemove.remove();
      } else {
        break;
      }
    }
  });

  return doc.body.innerHTML;
}
